exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._26fEWzZ5coxK40UKU6c678 .dnn-switch-container {\n  width: 100%;\n}\n._26fEWzZ5coxK40UKU6c678 .dnn-switch-container .dnn-switch {\n  float: right;\n}\n", ""]);

// Exports
exports.locals = {
	"editAuthenticationSystem": "_26fEWzZ5coxK40UKU6c678"
};